import styled from 'styled-components'

export const TitleWrapper = styled.div`
	display: flex;
	flex-direction: column;
`
